import {SectionView} from '../../ui_canvas_engine/SectionView'
import {PIXI} from '@colonist/pixi'
import {GameColor} from '../../GameColor'
import {InGameAchievement} from './UIGameAchievementController'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameFont} from '../../GameFont'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {TranslationObject} from '@colonist/i18n'

export class UIGameAchievementTitleSectionView extends SectionView {
    private readonly achievementOptions: InGameAchievement
    private readonly margin: number

    private scoreCount?: TextView

    constructor(x: number, y: number, width: number, height: number, parent: PIXI.Container, options: InGameAchievement, margin: number) {
        super(x, y, width, height, parent)
        this.achievementOptions = options
        this.margin = margin
    }

    createTitle() {
        const width = this.width * 0.7
        const textView = new TextView(this.achievementOptions.title, this.margin, 0, width, this.height, this, GameFont.Size.L, GameColor.getColor(GameColor.Color.White))
        textView.makeSemiBold()
    }

    createAchievementScore() {
        const scoreCount = this.achievementOptions.achievementScore
        if(scoreCount == undefined) return

        const scoreCountText: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: scoreCount}}
        this.scoreCount = new TextView(scoreCountText, 0, 0, this.width, this.height, this, GameFont.Size.L, GameColor.getColor(GameColor.Color.White))
        this.scoreCount.x = this.width - this.scoreCount.width - this.margin
        this.scoreCount.makeBold()
    }

    createAchievementIcon() {
        const iconTexture = this.achievementOptions.iconTexture
        const scoreCountX = this.scoreCount == undefined ? this.width : this.scoreCount.x + this.margin / 2
        const iconWidth = this.width * 0.07
        const iconX = scoreCountX - iconWidth - this.margin * 1.2
        const iconHeight = iconWidth * iconTexture.height / iconTexture.width
        const iconY = (this.height - iconHeight) / 2

        const achievementIcon = new SpriteView(iconX, iconY, iconWidth, iconHeight, this, iconTexture)

        if(this.achievementOptions.iconTextureSecondLayer == undefined) return
        this.createIconSecondLayer(achievementIcon, this.achievementOptions.iconTextureSecondLayer)
    }

    private createIconSecondLayer(achievementIcon: SpriteView, secondLayer: PIXI.Texture) {
        const x = achievementIcon.x + achievementIcon.width * 0.34
        const y = achievementIcon.y + achievementIcon.height * 0.05
        const width = achievementIcon.width * 0.9
        const height = width * secondLayer.height / secondLayer.width

        new SpriteView(x, y, width, height, this, secondLayer)
    }
}
